function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "rating-u_svg__a",
  d: "M.1 0h89.7v79.999H.1z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "rating-u_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rating-u_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M87.545 75.094a6.937 6.937 0 01-6.066 3.503H8.521a6.939 6.939 0 01-6.067-3.502 6.937 6.937 0 010-7.006l36.48-63.183a6.933 6.933 0 016.065-3.502c2.532 0 4.8 1.309 6.067 3.502l36.478 63.183a6.932 6.932 0 01.001 7.005m1.215-7.707L52.281 4.204A8.324 8.324 0 0045 0a8.324 8.324 0 00-7.28 4.203L1.238 67.388a8.324 8.324 0 000 8.408 8.323 8.323 0 007.282 4.203h72.96a8.322 8.322 0 007.281-4.203 8.325 8.325 0 000-8.41",
  fill: "#000",
  mask: "url(#rating-u_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M81.479 75.087H8.52c-2.691 0-4.373-2.913-3.027-5.243L41.972 6.66A3.464 3.464 0 0145 4.913c1.177 0 2.354.582 3.027 1.747l36.478 63.184c1.346 2.33-.336 5.243-3.026 5.243m6.065-6.998L51.066 4.905A6.936 6.936 0 0045 1.403c-2.533 0-4.8 1.31-6.067 3.502L2.455 68.09a6.932 6.932 0 000 7.006 6.935 6.935 0 006.066 3.502h72.958c2.532 0 4.8-1.31 6.066-3.503a6.932 6.932 0 00-.001-7.005",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.027 6.66A3.463 3.463 0 0045 4.915a3.464 3.464 0 00-3.028 1.747L5.494 69.845c-1.346 2.33.336 5.243 3.027 5.243h72.958c2.69 0 4.372-2.913 3.027-5.243L48.026 6.66z",
  fill: "#0AC700"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.269 38.545v17.626c-.04 3.17-.04 5.782-3.011 8.316-2.851 2.497-6.535 2.735-8.435 2.735-1.704 0-3.368-.198-4.953-.752-3.328-1.15-5.11-3.566-5.744-5.664-.356-1.228-.356-2.1-.396-5.586V38.545h5.229v17.19c0 1.19-.04 2.337.357 3.408 1.069 2.692 4 3.008 5.664 3.008.832 0 2.932-.039 4.476-1.385C51 59.38 51 57.796 51 55.458V38.545h5.269z",
  fill: "#FFF"
}));

function SvgRatingU(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 80"
  }, props), _ref, _ref2);
}

export default SvgRatingU;